import Axios from 'axios';
import {urlAPIDirectus} from "../config/Globals";

function findAll(){
    return Axios
        .get(urlAPIDirectus+"Patenaire?filter[status][_eq]=published")
        .then(response => response.data.data);
}

export default {
    findAll
}